<template>
  <a-modal
    :title="
      status == 'add' ? '课程 - 添加' : status == 'preview' ? '课程预览' : title
    "
    :width="status == '1' ? width : status == 'preview' ? 1000 : 600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleCancel"
    @cancel="handleCancel"
    cancelText="取消"
  >
    <template v-if="status == 'add' || status == 'edit'" slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" @click="goNext">
        生成预览
      </a-button>
    </template>
    <template v-if="status == 'preview'" slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" @click="submitCourse">
        确认
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading" style="min-height: 500px">
      <!-- 已有课程 -->
      <div v-if="status == '1'">
        <a-form>
          <a-form-item
            style="margin-bottom: 0px"
            label="当前课程"
            :labelCol="labelCol2"
            :wrapperCol="wrapperCol2"
          >
            <span class="ant-form-text">{{ hasCourse.packName }} </span>
          </a-form-item>
          <a-form-item
            style="margin-bottom: 0px"
            label="训练营ID"
            :labelCol="labelCol2"
            :wrapperCol="wrapperCol2"
          >
            <span class="ant-form-text">
              {{ hasCourse.no ? hasCourse.no : '--' }}
            </span>
          </a-form-item>
          <a-form-item
            style="margin-bottom: 0px"
            label="开课时间"
            :labelCol="labelCol2"
            :wrapperCol="wrapperCol2"
          >
            <span class="ant-form-text">{{ hasCourse.start_time }}</span>
          </a-form-item>
          <a-form-item
            style="margin-bottom: 0px"
            label="当前进度"
            :labelCol="labelCol2"
            :wrapperCol="wrapperCol2"
          >
            <span class="ant-form-text">
              {{
                hasCourse.status == 0
                  ? '未开始'
                  : hasCourse.status == 1
                  ? '进行中'
                  : '已结束'
              }}
            </span>
          </a-form-item>
          <a-form-item
            style="margin-bottom: 0px"
            label="班主任"
            :labelCol="labelCol2"
            :wrapperCol="wrapperCol2"
          >
            <span class="ant-form-text"> {{ hasCourse.headmasterName }} </span>
          </a-form-item>
          <a-form-item
            style="margin-bottom: 0px"
            label="助教"
            :labelCol="labelCol2"
            :wrapperCol="wrapperCol2"
          >
            <span class="ant-form-text"> {{ hasCourse.assistantName }} </span>
          </a-form-item>
          <a-button style="margin-left: 80%" @click="edit">编辑</a-button>
          <!-- <a-button style="margin-left: 80%" @click="status = 'list'">查询</a-button> -->
          <a-form-item label="课程详情">
            <details-modal></details-modal>
          </a-form-item>
        </a-form>
      </div>
      <!-- 暂无课程 -->
      <div
        v-else-if="status == '0'"
        style="line-height: 500px; text-align: center"
      >
        <a href="javascript:void(0)" @click="status = 'add'">
          当前群聊暂无课程，点击添加 >
        </a>
      </div>

      <!-- 添加 -->
      <div v-else-if="status == 'add' || status == 'edit'">
        <a-form-model :model="form" ref="ruleForm" :rules="rules">
          <a-form-model-item
            label="课程选择"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="name"
          >
            <a @click="openCourseDrawer()">点击选择课程</a>
            <!-- {{this.form.getFieldValue('courseList')}} -->
            <!-- 课程选择抽屉 -->
            <a-drawer
              title="选择课程"
              width="650"
              :closable="false"
              :body-style="{ paddingBottom: '80px' }"
              :visible="visibleshowuser"
              @close="onClose"
            >
              <a-row
                type="flex"
                justify="space-around"
                style="margin-bottom: 20px"
                align="middle"
              >
                <a-col :span="3">
                  课程名称:
                  <!-- <div style="display:flex;justify-content:space-between;width:195px">
                    <p style="width:100px;line-height:35px">课程名称:</p><a-input placeholder="请输入课程名称" />
                  </div> -->
                </a-col>
                <a-col :span="8">
                  <a-input
                    v-model="queryParam.name"
                    placeholder="请输入课程名称"
                  />
                </a-col>
                <a-col :span="3"> 课程类型: </a-col>
                <a-col :span="8">
                  <a-select
                    v-model="queryParam.level"
                    style="width: 200px"
                    placeholder="请选择课程类型"
                  >
                    <a-select-option :value="null">请选择</a-select-option>
                    <a-select-option :value="1">初级课程</a-select-option>
                    <a-select-option :value="2">中级课程</a-select-option>
                    <a-select-option :value="3">高级课程</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-button @click="searchReset" style="margin-left: 75%">
                重置
              </a-button>
              <a-button
                type="primary"
                @click="searchQuery"
                style="margin-left: 20px; margin-bottom: 20px"
              >
                查询
              </a-button>
              <a-table
                ref="table"
                size="small"
                :columns="columns"
                :dataSource="dataSource"
                :rowKey="r => r.key"
                v-model="courseList"
                :rowSelection="{
                  selectedRowKeys: selectedRowKeys,
                  onChange: tableSelect,
                  type: 'radio'
                }"
              ></a-table>
              <!-- v-decorator="['courseList', { rules: [{ required: true, message: '请选择课程!'}] }]" -->

              <div
                :style="{
                  position: 'absolute',
                  right: 0,
                  bottom: 0,
                  width: '100%',
                  borderTop: '1px solid #e9e9e9',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'right',
                  zIndex: 1
                }"
              >
                <a-button :style="{ marginRight: '8px' }" @click="onClose">
                  取消
                </a-button>
                <a-button type="primary" @click="addCourse"> 确定 </a-button>
              </div>
            </a-drawer>
            <div>
              <a-tag
                v-for="(item, index) in courseTagList"
                :key="index"
                closable
                @close.prevent="closeUserTag(index)"
              >
                {{ item.name }}
              </a-tag>
            </div>
            <a-input
              :max-length="3"
              style="width: 100px;display:none"
              placeholder="请输入"
              v-model="form.name"
            ></a-input>
          </a-form-model-item>
          <!-- 班主任选择 -->
          <teacher-modal
            ref="teacherModal"
            :headmasterId="headmasterId"
            :headmasterName="headmasterName"
            :groupChatId="groupChatId"
            :teaform="form"
          ></teacher-modal>
          <!-- 助教选择 -->
          <assistant-modal
            ref="assistantModal"
            :groupChatId="groupChatId"
            :teaform="form"
          ></assistant-modal>
          <a-form-model-item
            prop="starttime"
            label="开课时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <!-- <a-time-picker format="HH:mm" v-decorator="['wanTime', {
              initialValue: moment('12:00', 'HH:mm'),
              rules: [{ required: true, message: '请输入晚课时间' }],
            }]" />-->
            <a-date-picker
              v-model="form.starttime"
              @change="startTimeChange"
              style="width: 200px"
            />
          </a-form-model-item>
          <a-form-model-item
            label="上课时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="classTime"
          >
            <!-- <a-time-picker format="HH:mm" v-decorator="['wanTime', {
              initialValue: moment('12:00', 'HH:mm'),
              rules: [{ required: true, message: '请输入晚课时间' }],
            }]" />-->
            <a-select
              style="width: 200px"
              placeholder="每天(默认)"
              v-model="form.classTime"
              @change="handleProvinceChange"
            >
              <!-- :defaultValue='defaultClassTime' -->

              <a-select-option key="1">每天(默认)</a-select-option>
              <a-select-option key="2">周一至周五</a-select-option>
              <a-select-option key="3">周末</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            prop="day_add_t"
            label="开课时间为T, T+"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              :max-length="3"
              type="number"
              style="width: 100px"
              placeholder="请输入"
              v-model="form.day_add_t"
            ></a-input>
            日开始正式授课
          </a-form-model-item>
          <a-form-model-item
            prop="day_interval"
            label="不同课程时间间隔"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              :max-length="3"
              type="number"
              style="width: 100px"
              placeholder="请输入"
              v-model="form.day_interval"
            ></a-input>
            天
          </a-form-model-item>
          <!-- <a-row type="flex" justify="space-around" style="margin-left: 5px" align="middle">
            <a-col > 早课时间： </a-col>
            <a-col > 午课时间： </a-col>
            <a-col > 晚课时间： </a-col> 
          </a-row>-->
          <a-form-model-item
            prop="morningtime"
            label="早课时间："
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-time-picker v-model="form.morningtime" format="HH:mm" />
          </a-form-model-item>
          <a-form-model-item
            prop="noontime"
            label="午课时间："
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-time-picker v-model="form.noontime" format="HH:mm" />
          </a-form-model-item>
          <a-form-model-item
            prop="afternoontime"
            label="晚课时间："
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-time-picker v-model="form.afternoontime" format="HH:mm" />
          </a-form-model-item>
          <!-- <a-row type="flex" justify="space-between" style="margin-bottom: 20px; margin-left: 60px" align="middle">
            <a-col>
             
            </a-col>
            <a-col>
              
              
            </a-col>
            <a-col>
              
            </a-col>
          </a-row> -->
        </a-form-model>
      </div>
      <!-- 预览 -->
      <div v-else-if="status == 'preview'">
        <a-table :columns="columns1" :data-source="data1">
          <span slot="courseTime" slot-scope="text, record">
            {{ text }}
            <a-icon type="form" @click="showTimeChose(record)" />
          </span>
        </a-table>
        <a-modal v-model="timeChose" title="修改时间" @ok="timeChoseOk">
          <a-date-picker
            show-time
            :placeholder="placeholder"
            @change="onChange"
            v-decorator="['timeChose']"
          />
        </a-modal>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import TeacherModal from './modlues/teacherModal';
import AssistantModal from './modlues/assistantModal';
import DetailsModal from './modlues/detailsModal';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JUpload from '@/components/jeecg/JUpload';
import { httpAction, postTag } from '@/api/manage';
import { getCourse, coursePackList } from '@/api/api';

import moment from 'moment';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
const columns = [
  {
    title: '课程名称',
    align: 'center',
    dataIndex: 'name'
  },
  {
    title: '课程类型',
    align: 'center',
    dataIndex: 'level',
    customRender: function(text, record, index) {
      if (text === 1) {
        return '初级课程';
      } else if (text == 2) {
        return '中级课程';
      } else {
        return '高级课程';
      }
    }
  },
  {
    title: '课程安排',
    align: 'center',
    dataIndex: 'dayCount',
    customRender: function(text, record, index) {
      return text + '天';
    }
  },
  {
    title: '创建时间',
    align: 'center',
    dataIndex: 'createTime'
  }
];
const columns1 = [
  {
    title: '课程主题',
    align: 'center',
    dataIndex: 'theme'
  },
  {
    title: '授课时间',
    align: 'center',
    dataIndex: 'startTime',
    scopedSlots: {
      customRender: 'courseTime'
    }
  },
  {
    title: '课程内容',
    align: 'center',
    dataIndex: 'name',
    ellipsis: true
  },
  {
    title: '课程时长(分钟)',
    align: 'center',
    dataIndex: 'last'
  }
];

export default {
  name: 'courseManageModal',
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    JImageUpload,
    JUpload,
    TeacherModal,
    AssistantModal,
    DetailsModal
  },
  data() {
    return {
      name: 'courseManageModal',
      dataSource: [],
      data1: [],
      columns,
      title: '课程管理',
      status: '',
      form: {
        name: '',
        starttime: '',
        classTime: [],
        day_add_t: '',
        day_interval: '',
        morningtime: undefined,
        noontime: undefined,
        afternoontime: undefined,
        teacher: [], //班主任
        assistant: [] //助教
      },
      width: 1000,
      visible: false,
      assistantsName: '',
      teacher: [],
      assistant: [],
      courseList: [],
      starttime: '',
      classTime: [],
      day_add_t: '',
      day_interval: '',
      model: {
        courseList: []
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      labelCol2: {
        xs: {
          span: 22
        },
        sm: {
          span: 4
        }
      },
      wrapperCol2: {
        xs: {
          span: 24
        },
        sm: {
          span: 6
        }
      },
      confirmLoading: false,
      url: {
        list: process.env.VUE_APP_CMS_COURSE + '/course/findCoursePack',
        add: process.env.VUE_APP_CMS_PRODUCT + '/course-biz/class/addClass',
        edit:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsOrganization/edit'
        // addClass: process.env.VUE_APP_CMS_PRODUCT + '/course-biz/class/addClass',
      },
      rules: {
        name: [{ required: true, message: '请选择课程', trigger: 'blur' }],
        teacher: [{ required: true, message: '请选择班主任', trigger: 'blur' }],
        assistant: [{ required: true, message: '请选择助教', trigger: 'blur' }],
        starttime: [
          { required: true, message: '请选择开课时间', trigger: 'change' }
        ],
        classTime: [
          { required: true, message: '请选择上课时间', trigger: 'blur' }
        ],
        day_add_t: [
          { required: true, message: '请输入时间正式授课', trigger: 'blur' }
        ],
        day_interval: [
          { required: true, message: '请输入不同课程时间间隔', trigger: 'blur' }
        ],
        morningtime: [
          { required: true, message: '请选择早课时间', trigger: 'change' }
        ],
        noontime: [
          { required: true, message: '请选择午课时间', trigger: 'change' }
        ],
        afternoontime: [
          { required: true, message: '请选择晚课时间', trigger: 'change' }
        ]
      },
      checkedKeys: '',
      visibleshowuser: false,

      morningtime: '',
      noontime: '',
      afternoontime: '',
      columns1,
      timeChose: false,
      placeholder: '',
      changeTimeId: '',
      timeChangedString: '',
      addData: {},
      groupChatId: '',
      classCourseList: [],
      hasCourse: {},
      ClassId: '',
      headmasterId: '',
      headmasterName: '',
      defaultClassTime: '',
      courseTagList: [],
      courseTagKeys: []
    };
  },
  methods: {
    // 打开课程选择弹窗
    openCourseDrawer() {
      this.visibleshowuser = !this.visibleshowuser;
    },
    // 删除标签
    closeUserTag(i) {
      this.selectedRowKeys.splice(i, 1);
      this.selectionRows.splice(i, 1);
      this.courseList.splice(i, 1);
      this.courseTagList.splice(i, 1);
      // this.form={
      //   starttime: '',
      //   classTime: [],
      //   day_add_t: '',
      //   day_interval: '',
      // }
      this.form.name = '';
      console.log('courseTagList', this.courseTagList);
    },
    // 选择课程弹窗确定回调
    addCourse() {
      this.courseList = this.selectedRowKeys;
      // let courseList = this.selectedRowKeys
      // this.form.setFieldsValue({
      //   courseList,
      // })
      this.courseTagList = this.selectionRows;
      this.courseTagKeys = this.selectedRowKeys;

      let obj = {};
      let index = this.dataSource.findIndex(
        item => item.id == this.selectedRowKeys[0]
      );
      if (index > -1) {
        let e = this.dataSource[index];
        this.day_add_t = e.day_add_t;
        this.day_interval = e.day_interval;
        this.form.name = e.name;
        this.form.morningtime = e.am_course_time
          ? moment(e.am_course_time, 'HH:mm:ss')
          : undefined;
        this.form.noontime = e.noon_course_time
          ? moment(e.noon_course_time, 'HH:mm:ss')
          : undefined;
        this.form.afternoontime = e.pm_course_time
          ? moment(e.pm_course_time, 'HH:mm:ss')
          : undefined;
      }
      // this.dataSource.forEach(e=>{
      //   if(e.id==this.selectedRowKeys[0]){
      //     this.day_add_t=e.day_add_t
      //     this.day_interval=e.day_interval
      //     this.form.name= e.name;
      //     this.form.morningtime=moment(e.am_course_time, 'HH:mm:ss')
      //     this.form.noontime=moment(e.noon_course_time, 'HH:mm:ss')
      //     this.form.afternoontime=moment(e.pm_course_time, 'HH:mm:ss')
      //   }
      // })
      this.onClose();
    },
    moment,
    add(a) {
      console.log(a);
      this.visible = true;
      this.groupChatId = a.chat_id;
      // 查询当前群聊是否有课程
      getCourse({
        groupId: a.chat_id
      })
        .then(res => {
          if (!res.result) {
            this.status = '0';
          } else {
            this.ClassId = res.result.id;
            this.hasCourse = res.result;
            this.status = '1';
            sessionStorage.setItem('CLASSID', res.result.id);
            // this.$nextTick(() => {
            //   Bus.$emit('getList',res.result.id)
            // })
          }
        })
        .catch(err => {
          console.log(err);
        });
      // 课程选择列表获取
      coursePackList()
        .then(res => {
          this.dataSource = res.result.records;
          this.dataSource.map(e => (e.key = e.id));
        })
        .catch(err => {
          console.log(err);
        });
      this.$nextTick(() => {
        this.selectedRowKeys = [];
        this.selectionRows = [];
      });
    },
    edit() {
      this.courseList = [];
      this.starttime = '';
      this.classTime = [];
      this.day_add_t = '';
      this.day_interval = '';
      this.status = 'edit';
      this.headmasterId = this.model.headmaster_id;
      this.headmasterName = this.model.headmasterName;
      this.morningtime = '';
      this.noontime = '';
      this.afternoontime = '';
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.model = Object.assign(this.model, this.hasCourse);
      let that = this;
      setTimeout(() => {
        that.courseList[0] = that.model.course_pack_id;
        that.selectionRows[0] = {};
        that.selectionRows[0].key = that.model.course_pack_id;
        that.selectionRows[0].name = that.model.packName;
        that.selectedRowKeys[0] = that.model.course_pack_id;
        that.courseTagList = that.selectionRows;
        that.form.starttime = moment(that.model.start_time, 'YYYY-MM-DD');
        that.form.classTime.push(that.model.day_type + '');
        that.form.day_add_t = that.model.day_add_t;
        that.form.day_interval = that.model.day_interval;
        that.form.name = that.model.packName;
        that.form.morningtime = moment(that.model.am_course_time, 'HH:mm:ss');
        that.form.noontime = moment(that.model.noon_course_time, 'HH:mm:ss');
        that.form.afternoontime = moment(that.model.pm_course_time, 'HH:mm:ss');

        console.log(that.model.assistant_id);
        if (that.model.assistant_id.split(',').length > 1) {
          let arr = that.model.assistant_id.split(',');
          arr.forEach(e => {
            that.$refs.assistantModal.selectedRowKeys.push(e);
            that.$refs.assistantModal.assistantList.push(e);
            that.assistant.push(e);
          });

          let arr1 = that.model.assistantName.trim().split(' ');
          console.log(arr1, that.model.assistantName.trim(), '===========');
          for (let i = 0; i < arr1.length; i++) {
            let obj = {};
            obj.key = arr[i];
            obj.name = arr1[i];
            that.$refs.assistantModal.selectionRows.push(obj);
          }
          console.log(that.$refs.assistantModal.selectionRows, '>>>>');
        } else {
          console.log(that.model, '>>>>');
          let assistantTagList = JSON.parse(
            sessionStorage.getItem('assistantTagList')
          );
          that.assistantsName = assistantTagList
            ? assistantTagList[0].name
            : '';
          let assistant_id = assistantTagList[0].assistant_id;
          console.log(assistantTagList[0], '>>>', that.assistantsName);
          that.$refs.assistantModal.selectedRowKeys[0] =
            that.model.assistant_id;
          that.$refs.assistantModal.assistantList[0] = that.model.assistant_id;
          that.$refs.assistantModal.selectionRows[0] = {};
          that.$refs.assistantModal.selectionRows[0].key = assistant_id;
          that.$refs.assistantModal.selectionRows[0].name = that.assistantsName;
          console.log(
            that.$refs.assistantModal.selectionRows,
            that.assistantsName
          );
        }
        that.form.assistant = that.$refs.assistantModal.selectionRows;

        that.$refs.teacherModal.selectedRowKeys[0] = that.model.headmaster_id;
        that.$refs.teacherModal.teacherList[0] = that.model.headmaster_id;
        that.$refs.teacherModal.selectionRows[0] = {};
        that.$refs.teacherModal.selectionRows[0].key = that.model.headmaster_id;
        that.$refs.teacherModal.selectionRows[0].name =
          that.model.headmasterName;
        that.form.teacher = that.$refs.teacherModal.teacherList;

        console.log('****************', that.form);

        console.log(
          that.$refs.teacherModal,
          that.$refs.teacherModal.teacherList,
          that.$refs.assistantModal.assistantList,
          '+++++++++++++++++'
        );
      }, 0);
    },
    // 选择课程后生产预览
    goNext() {
      const that = this;
      console.log(this.form);

      this.$refs.ruleForm.validate((valid, valuse) => {
        if (valid) {
          let clazz = {};
          clazz.headmasterId = this.$refs.teacherModal.teacherList[0];
          clazz.assistantId = [
            ...new Set(this.$refs.assistantModal.assistantList)
          ];
          if (clazz.assistantId.length > 1) {
            clazz.assistantId = clazz.assistantId.join(',');
          } else {
            clazz.assistantId = clazz.assistantId[0];
          }
          clazz.coursePackId = this.courseList[0];
          clazz.amCourseTime = moment(that.form.morningtime).format('HH:mm:ss');
          clazz.noonCourseTime = moment(that.form.noontime).format('HH:mm:ss');
          clazz.pmCourseTime = moment(that.form.afternoontime).format(
            'HH:mm:ss'
          );
          clazz.startTime = moment(that.form.starttime).format('YYYY-MM-DD');
          clazz.dayAddT = this.form.day_add_t;
          clazz.dayInterval = this.form.day_interval;
          clazz.dayType = this.form.classTime[0];
          clazz.groupchatId = this.groupChatId;
          this.addData.clazz = clazz;
          postTag(
            process.env.VUE_APP_CMS_COURSE + '/class/calculateCourseTime',
            clazz
          ).then(res => {
            console.log(res);
            if (res.success) {
              this.classCourseList = [];
              this.data1 = res.result;
              this.status = 'preview';
              this.data1.forEach(e => {
                let obj = {};
                obj.courseId = e.courseId;
                obj.startTime = e.startTime;
                this.classCourseList.push(obj);
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    // 确定预览后确认回调
    submitCourse() {
      this.visible = false;
      this.visibleshowuser = false;
      this.addData.classCourseList = this.classCourseList;
      console.log(this.addData);
      postTag(
        process.env.VUE_APP_CMS_COURSE + '/class/addClass',
        this.addData
      ).then(res => {
        console.log(res);
      });
    },
    // 关闭弹窗按钮
    close() {
      this.visible = false;
    },
    // 选择课程侧边栏关闭
    onClose() {
      this.visibleshowuser = false;
    },
    // 取消回调
    handleCancel() {
      if (this.status == 'add') {
        this.status = '0';
      } else if (this.status == 'edit') {
        this.status = '1';
        // Bus.$emit('getList',this.ClassId)
      } else {
        this.close();
      }
    },
    // 上课时间修改回调
    handleProvinceChange(value) {
      this.classTime = value;
      this.form.classtime = value;
      // let classtime = this.form.getFieldValue('classtime') || []
      // classtime = [...classtime, value]
      // this.form.setFieldsValue({
      //   classtime,
      // })
      // console.log(this.form.getFieldValue('classtime'))
    },
    // 开课时间修改回调
    startTimeChange(data, dataString) {
      // let starttime = this.form.getFieldValue('starttime') || []
      // starttime = [...starttime, dataString]
      // this.form.setFieldsValue({
      //   starttime,
      // })
      this.startTime = data;
      console.log(data, dataString, this.form.starttime);
    },
    // 预览时间变化回调
    onChange(value, dateString) {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
      this.timeChangedString = dateString;
    },
    // 预览修改时间弹窗
    showTimeChose(record) {
      // this.form.setFieldsValue({'timeChose':''})
      // this.form.resetFields(['timeChose']);
      this.changeTimeId = record.id;
      this.timeChose = true;
      this.placeholder = record.startTime;
      console.log(record);
      let timeChose = moment(record.startTime, 'YYYY-MM-DD HH:mm:ss');
      // this.form.setFieldsValue({timeChose})
    },
    // 预览修改时间确定回调
    timeChoseOk() {
      this.timeChose = false;
      this.data1.forEach(e => {
        if (e.id == this.changeTimeId) {
          e.startTime = this.timeChangedString;
        }
      });
    },
    // 课程选择修改回调
    tableSelect(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    changeFormData(flg, value) {
      this.form[flg] = value;
    }
  }
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
